<template>
  <masked-input
      type="text"
      :name="name"
      :class="styleClass"
      v-model="val"
      :mask="['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
      :guide="true">
    </masked-input>
</template>

<script>

import MaskedInput from 'vue-text-mask'
import MaskInput from 'vue-text-mask';

export default {
    name: 'aha-masked-input',
    inheritAttrs: true,
    components: {
        MaskedInput,
    },
    data() {
        return {
            val: '',
        }
    },
    props: {
        name: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        styleClass: String
    },
    calulated: {
        mask(){
            let mask = '';
            switch(this.type) {
                case 'phone': 
                    mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                    break;
                case 'date': 
                    mask = [/[0-1]/, /[0-9]/, '/', /[1-3]/, /[0-9]/, '/', /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/];
                    break;
            }
            return mask;
        }
    }
}


</script>

<style>

</style>


// WEBPACK FOOTER //
// src/app/components/aha-masked-input.vue